// extracted by mini-css-extract-plugin
module.exports = {"icon":"__1vLQDMBD","personal":"Xh2jjktU","company":"JDrg1c8h","text":"h_JNBZCf"};